export enum CrmNotificationType {
  POST_MENTION = 'POST_MENTION',
  COMMENT_MENTION = 'COMMENT_MENTION',
  COMMENT_REPLY = 'COMMENT_REPLY'
}

export interface CrmNotificationData {
  actorId?: string | null;
  actorName?: string | null;
  body?: string | null;
  recordId?: string | null;
  recordName?: string | null;
  recordType?: string | null;
  feedItemId?: string | null;
  commentId?: string | null;
}

export interface CrmNotification {
  id: string;
  type: CrmNotificationType;
  userId: string;
  isRead: boolean;
  relatedId: string;
  relatedType?: string | null;
  relatedName?: string | null;
  data?: CrmNotificationData | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface GetCrmNotificationsResponse {
  getCrmNotifications: {
    notifications: CrmNotification[];
    totalCount: number;
  };
}

export interface CrmNotificationFilter {
  relatedId?: string;
  isRead?: boolean;
  limit?: number;
  offset?: number;
}

export interface MarkAllCrmNotificationsAsReadResponse {
  markAllCrmNotificationsAsRead: {
    updatedCount: number;
  };
}
